const withCommonRoot = require('client-v2/common/components/root')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const Portal = require('client-v2/common/components/portal')
const tag = require('client-v2/common/utils/hyperscript')
const AppFooter = require('client-v2/common/containers/app-footer/component-smart')
const AppNav = require('client-v2/common/containers/app-nav/component-smart')
const ConfirmModal = require('client-v2/common/containers/confirm-modal/component-smart')
// Entry imports
const BannerSection = require('client-v2/logged-out-landing/containers/banner-section/component-smart')
const DeviceSection = require('client-v2/logged-out-landing/components/device-section')
const FeedSection = require('client-v2/logged-out-landing/components/feed-section')
const HeroSection = require('client-v2/logged-out-landing/containers/hero-section/component-smart')
const MixSection = require('client-v2/logged-out-landing/components/mix-section')

const bem = BemEntity('LoggedOutLandingLayout')

function LoggedOutLandingLayout() {
  return (
    tag('div', {
      className: bem.block()
    },
      tag('div', {
        className: bem.element('page')
      },
        tag('div', {
          className: bem.element('body'),
          role: 'main'
        },
          tag(BannerSection),
          tag(FeedSection),
          tag(HeroSection),
          tag(MixSection),
          tag(DeviceSection)
        ),
        tag(AppFooter),
        tag(AppNav, {
          className: 'AppNav--mobile'
        })
      ),
      Portal.toModalRoot(
        tag(ConfirmModal)
      )
    )
  )
}

const wrappedComponent = withCommonRoot(LoggedOutLandingLayout)
module.exports = Object.assign(wrappedComponent, {
  // Export unwrapped component for testing purposes
  LoggedOutLandingLayout
})
